export default __webpack_public_path__ + "static/media/verify_bg3.bbfe820f.png";